// extracted by mini-css-extract-plugin
export default {"mainHeader":"styles_mainHeader__gnyX9","secondHeader":"styles_secondHeader__cOZVq"};